import React from 'react';
import ReactDOM from 'react-dom';

interface PDFLoadingModalProps {
  isOpen: boolean;
  progress?: number;
}

const PDFLoadingModal: React.FC<PDFLoadingModalProps> = ({ isOpen, progress = 0 }) => {
  console.log('PDFLoadingModal - isOpen:', isOpen, 'progress:', progress);
  
  if (!isOpen) return null;

  const modalContent = (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full mx-4 transform transition-all duration-300 scale-100">
        <div className="text-center">
          {/* Animated PDF Icon */}
          <div className="relative inline-block mb-6">
            <div className="w-24 h-24 bg-primary-100 rounded-xl flex items-center justify-center relative overflow-hidden">
              <svg
                className="w-12 h-12 text-primary-600 z-10"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-5L9 2H4z" clipRule="evenodd" />
              </svg>

              {/* Animated waves */}
              <div className="absolute inset-0 flex items-end">
                <div className="w-full h-1/2 bg-primary-200 opacity-50 animate-pulse" />
              </div>
              <div className="absolute inset-0 flex items-end">
                <div
                  className="w-full bg-primary-400 transition-all duration-500 ease-out"
                  style={{ height: `${progress}%` }}
                />
              </div>
            </div>
            
            {/* Spinning circle loader */}
            <div className="absolute -top-2 -right-2">
              <div className="relative">
                <div className="w-8 h-8">
                  <svg className="animate-spin" viewBox="0 0 24 24">
                    <circle 
                      className="opacity-25" 
                      cx="12" 
                      cy="12" 
                      r="10" 
                      stroke="currentColor" 
                      strokeWidth="4"
                      fill="none"
                    />
                    <path
                      className="opacity-75 text-primary-600"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <h3 className="text-xl font-semibold text-secondary-800 mb-2">
            กำลังสร้างเอกสาร PDF
          </h3>

          <p className="text-secondary-600 mb-6">
            กรุณารอสักครู่ ระบบกำลังประมวลผลเอกสารของคุณ
          </p>

          {/* Progress bar */}
          <div className="w-full bg-secondary-200 rounded-full h-2 mb-4 overflow-hidden">
            <div
              className="bg-gradient-to-r from-primary-500 to-primary-600 h-2 rounded-full transition-all duration-500 ease-out relative"
              style={{ width: `${progress}%` }}
            >
              <div className="absolute inset-0 bg-white opacity-30 animate-shimmer" />
            </div>
          </div>

          {/* Progress text */}
          <p className="text-sm text-secondary-500">
            {progress > 0 ? `${progress}% เสร็จสิ้น` : 'กำลังเริ่มต้น...'}
          </p>

          {/* Animated dots */}
          <div className="flex justify-center mt-4 space-x-1">
            <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce" style={{ animationDelay: '0s' }} />
            <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
            <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }} />
          </div>
        </div>
      </div>
    </div>
  );
  
  // Use portal to render modal at the root level
  return ReactDOM.createPortal(
    modalContent,
    document.body
  );
};

export default PDFLoadingModal;